export default "__VITE_PUBLIC_ASSET__e665dfed__"